import React from 'react'

import { Carousel } from 'primereact/carousel'
import { numberConversion } from '../../../../utils'

const responsiveOptions = [
    {breakpoint: '1400px', numVisible: 2, numScroll: 1},
    {breakpoint: '1199px', numVisible: 2, numScroll: 1},
    {breakpoint: '767px', numVisible: 2, numScroll: 1},
    {breakpoint: '575px', numVisible: 1, numScroll: 1}
]


const FrequentlyBought = (props) => {
	const { products, frequentlyBoughtMaterialIds, materialBrands, handleViewProduct, minimumLength } = props
	
	const frequentlyBoughtProducts = products.filter(eachProduct => frequentlyBoughtMaterialIds.includes(eachProduct.materialId))

	const productTemplate = (product) => {
		const materialImage = product.materialImage?.length > 0 ? product.materialImage[0]
			: 'https://procmart-tech.s3.ap-south-1.amazonaws.com/app-images/no_image_no_pg+(6).png'

		const relatedMaterialBrand = materialBrands.find(eachMaterialBrand => eachMaterialBrand.brandId === product.brandId)

		return (
            <div 
                className="product-item ml-2" 
                onClick={() => handleViewProduct(product.buyerRateContractId)}
				style={{ height: "150px", cursor: 'pointer' }}
				onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1)')}
				onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
			>
                <div className="product-item-content flex flex-row">
                    <div className="w-3 product-img-container mr-2">
                        <img src={materialImage} onError={(e) => e.target.src = 'https://via.placeholder.com/150'} alt={product.name} className="" style={{ width: '80px', height: '80px', objectFit: 'cover' }} />
                    </div>
                    <div className="w-9 fle flex-column align-item-start justify-content-start">
						<h5 className="mb-1" style={{ fontWeight: '600', fontSize: '16px', color: '#333' }}>
							{product.companyProdName}
						</h5>
						<div className="mb-2" style={{ fontSize: '12px', color: '#555', minHeight:"20px" }}>
							{product.companyProdSpec}
						</div>
						{
                            relatedMaterialBrand ? 
                                <div className="mb-1" style={{ fontSize: '12px', color: '#777' }}>
                                    <span className="text-muted">Brand:&nbsp;</span>
                                    <span style={{ fontWeight: '500', color: '#333' }}>{relatedMaterialBrand.brandName}</span>
                                </div>
                            : null
                        }
						{
                            product.companyERPUOM ? 
                                <div className="mb-2" style={{ fontSize: '12px', color: '#777' }}>
                                    <span className="text-muted">Unit:&nbsp;</span>
                                    <span style={{ fontWeight: '500', color: '#333' }}>{product.companyERPUOM}</span>
                                </div>
						    : null
                        }
						<h6 className="mt-2 mb-1" style={{ color: '#0da487', fontWeight: 'bold' }}>₹ {numberConversion(product.unitPrice, "en-IN")}</h6>
                    </div>
                </div>
            </div>
		)
	}

	if(!frequentlyBoughtProducts.length || frequentlyBoughtProducts.length < minimumLength){
		return null
	}

	return (
		<div className='carousel-main-container pl-2'>
			<h3 className='mb-2'> Frequently Bought</h3>
			<div className="carousel-demo">
				<Carousel 
					value={frequentlyBoughtProducts} 
					numVisible={3} 
					numScroll={3} 
					responsiveOptions={responsiveOptions} 
					itemTemplate={productTemplate}
					circular
					autoplayInterval={3000} 
				/>
			</div>
		</div>
	)
}

export default FrequentlyBought